import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Role extends Model<Schemas['roles'], Models> {}

export const permissions = [
    {
        name: 'access-admin',
        label: 'Access Admin',
        description:
            'Access the admin area, view personal Inbox and Worklist, revise and comment on assigned items',
    },
    {
        name: 'manage-items',
        dependencies: ['access-admin'],
        label: 'Manage Items',
        description: 'Create, edit, and delete items/revisions, assign tags, view statistics',
    },
    {
        name: 'manage-feedback',
        dependencies: ['manage-items'],
        label: 'Manage Feedback',
        description: 'Respond to and delete user feedback',
    },
    {
        name: 'manage-packs',
        dependencies: ['access-admin'],
        label: 'Manage Packs',
        description: 'Create, edit, publish, and curate packs and collections',
    },
    {
        name: 'manage-products',
        dependencies: ['access-admin'],
        label: 'Manage Products',
        description: "Arrange products' study roadmaps and collection libraries",
    },
    {
        name: 'manage-tags',
        dependencies: ['access-admin'],
        label: 'Manage Tags',
        description: 'List, create, edit, and delete tags',
    },
    {
        name: 'manage-webinars',
        dependencies: ['access-admin'],
        label: 'Manage Webinars',
        description: 'Create, edit, and manage webinar certificate settings',
    },
];
